import { Component, ChangeDetectionStrategy, Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, ActivatedRoute, ParamMap, NavigationEnd }          from '@angular/router';
import { Angulartics2 } from 'angulartics2';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';



declare var particlesJS;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'startpage';
  notifyOptions = {
      position: ["bottom", "right"],
      timeOut: 5000,
      lastOnBottom: true
  };
  timeoutId=null;
    constructor(@Inject(PLATFORM_ID) private platform: any, private router: Router,  private route: ActivatedRoute,  angulartics2GoogleGlobalSiteTag: Angulartics2GoogleGlobalSiteTag, private angulartics2: Angulartics2) {
        angulartics2GoogleGlobalSiteTag.startTracking();
        this.router.events.subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    if(this.timeoutId != null) {
                        clearTimeout(this.timeoutId);
                    }
                    this.timeoutId = setTimeout(() => {
                        this.angulartics2.pageTrack.next({ path: event.urlAfterRedirects});
                    }, 500)
                }
            });
    }

  ngOnInit() {

  }


}
